import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateUser } from "../../models/admin/CreateUser";
import { UpdateUser } from "../../models/admin/UpdateUser";
import { Component } from "../../models/application-settings/Component";
import { Preference } from "../../models/application-settings/Preference";
import { PreferenceKey } from "../../models/application-settings/PreferenceKey";

const RESOURCE_NAME = "application";

const getTranslations = (languageCode: string) => {
  const http = getAxiosInstance();
  return http.get(
      `${RESOURCE_NAME}/getTranslations?languageCode=${languageCode}`,
      requestConfig()
  );
};

const getComponents = () => {
  const http = getAxiosInstance();
  return http.get<Component[]>(`${RESOURCE_NAME}/getComponents`, requestConfig());
};

const getPreferences = () => {
  const http = getAxiosInstance();
  return http.get<Preference[]>(`${RESOURCE_NAME}/getPreferences`, requestConfig());
};

const getReportingStatusByRecordTotals = (groupCode: string) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getReportingStatusByRecordTotals?groupCode=${groupCode}`, requestConfig());
}

const createPreference = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/createPreference`, model, requestConfig());
};

const updatePreference = (preferenceId: number, model: any) => {
  const http = getAxiosInstance();
  return http.put(
      `${RESOURCE_NAME}/updatePreference/${preferenceId}`,
      model,
      requestConfig()
  );
};

const getCustomQueryCategories = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getQueryCategories`, requestConfig());
};

const getCustomQueryTypes = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getQueryTypes`, requestConfig());
};

const deletePreference = (id: number) => {
  const http = getAxiosInstance();
  return http.delete(
      `${RESOURCE_NAME}/deletePreference/${id}`,
      requestConfig()
  );
};

const getCustomQueries = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getCustomQueries`, requestConfig());
};

const getCustomQuery = (id: number) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getCustomQuery/${id}`, requestConfig());
}

const createCustomQuery = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/createCustomQuery`, model, requestConfig());
};

const updateCustomQuery = (model: any) => {
  const http = getAxiosInstance();
  return http.put(
      `${RESOURCE_NAME}/updateCustomQuery/${model.id}`,
      model,
      requestConfig()
  );
};

const deleteCustomQuery = (id: string) => {
  const http = getAxiosInstance();
  return http.delete(
      `${RESOURCE_NAME}/deleteCustomQuery/${id}`,
      requestConfig()
  );
};

const getPreferenceKeys = () => {
  const http = getAxiosInstance();
  return http.get<PreferenceKey[]>(`${RESOURCE_NAME}/getPreferenceKeys`, requestConfig());
}

const getPreferenceValues = (key: string) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getPreferenceValues?key=${key}`, requestConfig());
}

const runCustomQuery = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/runCustomQuery`, model, requestConfig());
};

const ApplicationService = {
  getTranslations,
  getComponents,
  getPreferences,
  createPreference,
  updatePreference,
  deletePreference,
  getCustomQueries,
  getCustomQuery,
  createCustomQuery,
  updateCustomQuery,
  deleteCustomQuery,
  getReportingStatusByRecordTotals,
  getCustomQueryCategories,
  getCustomQueryTypes,
  getPreferenceKeys,
  getPreferenceValues,
  runCustomQuery
};
export default ApplicationService;
